import { injectable } from 'inversify';
import { BehaviorSubject } from 'rxjs';

import { ISyncStateRepository } from '../domain/abstractions/ISyncStateRepository';

@injectable()
export default class SyncStateRepository implements ISyncStateRepository {
  restoreStatus: BehaviorSubject<'idle' | 'isRestoring' | 'restored'> = new BehaviorSubject('idle');
}
